import { Timestamp } from "firebase/firestore";

export function convertTimestampToDate(ts: Timestamp) {
  return new Timestamp(ts.seconds, ts.nanoseconds).toDate();
}

export function convertDateToTimestamp(dt: Date) {
  console.log(dt);
  return new Timestamp(dt.getTime() / 1000, 0);
}
